angular.module('leanlaw').filter("checked", ['$filter', function ($filter) {
  return function (bool) {
    if (bool) return "x";
    return "";
  };
}]);